import { axiosClient, ensureApiPrefix, getPostHogHeaders, handleAuthenticationFailure } from "auth-sdk";
import axios from "axios";
import Cookies from "js-cookie";

let currentToken: string | undefined;
let interceptorId: number | null = null;

// Copy over the defaults and interceptor from the auth-sdk client
const instance = axios.create({ ...axiosClient.defaults });

instance.interceptors.request.use((config) => {
  config.url = ensureApiPrefix(config.url);
  return config;
});

// Request interceptor to inject PostHog session and user context headers
instance.interceptors.request.use((config) => {
  const posthogHeaders = getPostHogHeaders();
  Object.assign(config.headers, posthogHeaders);
  return config;
});

instance.interceptors.response.use((response) => {
  handleAuthenticationFailure(response);
  return response;
});

instance.interceptors.request.use((config) => {
  config.url = ensureApiPrefix(config.url);

  const csrfToken = Cookies.get("csrftoken");
  if (csrfToken) {
    config.headers["X-CSRFToken"] = csrfToken;
  }

  return config;
});

export const injectStepUpTokenIntoAxiosClientHeader = (token: string | undefined) => {
  if (token === currentToken) {
    return;
  }

  // Eject the previous interceptor if it exists
  if (interceptorId !== null) {
    instance.interceptors.request.eject(interceptorId);
  }

  currentToken = token;

  // Add the new interceptor and store its ID
  interceptorId = instance.interceptors.request.use((config) => {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  });
};

export const axiosSteppedUpClient = instance;
